import './utils/installConsoleDebug';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AppThemeProvider } from './theme/theme';
import { AdminErrorBoundary } from './components/AdminErrorBoundary';
import { logAdmin } from './utils/adminDebug';
import './i18n/config';

logAdmin('index.tsx loading', {
  mode: import.meta.env.MODE,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '(unset)',
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('#root element not found');
}

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <AdminErrorBoundary>
      <AppThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppThemeProvider>
    </AdminErrorBoundary>
  </React.StrictMode>
);

logAdmin('React root rendered');

